/**
 * Мелкие правила My Schedule и Group View — отдельно от экранов, чтобы их можно
 * было проверить тестом и чтобы два экрана не держали каждый свою копию.
 */
import { DOW, parseDay } from '../utils/scheduleDates';

/** Площадки сравниваем без регистра, крайних и двойных пробелов — как сервер. */
export function siteKey(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
}

/**
 * Что человек выбрал или вписал в поле площадки → название и коды работ.
 * Вписанное руками, но совпавшее с джобом из списка, получает его коды: без них
 * не посчитаются часы прораба.
 *
 * @returns {{ label: string, jobCodes: string[] }}
 */
export function pickLocation(value, locations = []) {
    const label = (typeof value === 'string' ? value : value?.label || '').trim().replace(/\s+/g, ' ');
    if (!label) return { label: '', jobCodes: [] };

    const match = locations.find((o) => siteKey(o.label) === siteKey(label));
    return match ? { label: match.label, jobCodes: match.jobCodes || [] } : { label, jobCodes: [] };
}

/** «Wed 09/23» */
export function dayTitle(workDate) {
    const d = parseDay(workDate);
    return `${DOW[d.getDay()]} ${d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' })}`;
}

/**
 * Люди в ячейке Group View.
 *
 * Новый сервер присылает всех списком (people), старый — одного (slots): экран
 * должен показывать и то и другое, пока айпады и сервер обновляются не разом.
 *
 * @returns {Array<{repId: ?number, name: string}>}
 */
export function peopleInCell(row, date) {
    const list = row?.people?.[date];
    if (Array.isArray(list)) return list;

    const single = row?.slots?.[date];
    if (Array.isArray(single)) return single;
    return single ? [single] : [];
}

/** «Burgess, Christopher Glenn» → фамилия отдельно, имя отдельно. */
export function splitName(fullName) {
    const name = (fullName || '').trim();
    const comma = name.indexOf(',');
    if (comma === -1) return { last: name, first: '' };
    return { last: name.slice(0, comma).trim(), first: name.slice(comma + 1).trim() };
}
